module.exports = __webpack_public_path__ + "static/make-video-slide5@2x-b0c9c32624eb60386708babe246b7251.png";